import { useState, useEffect } from 'react';

function buildApiUrl() {
  const now = new Date();
  const past = new Date(now);
  past.setMonth(past.getMonth() - 2);
  const future = new Date(now);
  future.setMonth(future.getMonth() + 9);

  const fmt = d => d.toISOString().slice(0, 10);

  return (
    `https://api.yogo.dk/event-time-slots` +
    `?client=757` +
    `&startDate=${fmt(past)}` +
    `&endDate=${fmt(future)}` +
    `&onlyEventsVisibleInCalendar=0` +
    `&includeArchived=1` +
    `&populate[0]=event` +
    `&populate[1]=event.image` +
    `&populate[2]=event.teachers` +
    `&populate[3]=event.event_group` +
    `&populate[4]=event.signup_count`
  );
}

export function useEvents() {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetch(buildApiUrl())
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(data => {
        if (!cancelled) {
          setSlots(Array.isArray(data) ? data : []);
          setLoading(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, []);

  return { slots, loading, error };
}
